<template>
  <BaseSmartGateAutocompleteSelect
    :warehouse-id="warehouseId"
    :field-label="fieldLabel"
    :field-name="fieldName"
    :field-max-length="7"
    :placeholder="placeholder"
    test-id="comet-asset-dot-number-field"
    custom-item-test-id="comet-use-custom-dot-number"
    custom-item-class="add-custom-dot-number"
    :data-mapper="dotNumberMapper"
    :rules="rules"
    :model-value="modelValue"
    :required="required"
    @update:model-value="$emit('update:model-value', $event)" />
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

import BaseSmartGateAutocompleteSelect from './BaseSmartGateAutocompleteSelect.vue';

export default defineComponent({
  components: {
    BaseSmartGateAutocompleteSelect
  },
  props: {
    warehouseId: {
      type: String,
      required: true
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: Object,
      default: null
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:model-value'],
  setup() {
    const { t } = useI18n();
    const fieldLabel = computed(() => t('smartGate.dotFieldLabel'));
    const fieldName = computed(() => t('smartGate.dotFieldName'));
    const placeholder = computed(() => t('smartGate.dotPlaceholder'));

    const dotNumberMapper = item => {
      if (item.dotNumber && item.dotNumber !== '') {
        return {
          name: item.dotNumber
        };
      }
    };

    return {
      dotNumberMapper,
      fieldLabel,
      fieldName,
      placeholder
    };
  }
});
</script>
